import { createNamespacedHelpers } from 'vuex'

const { mapState } = createNamespacedHelpers('notify')

export default {
  computed: mapState([
    'refreshError',
    'notFoundError',
    'requestError',
    'serverError'
  ]),
  watch: {
    refreshError (error) {
      if (error) {
        this.$awn.tip(this.$t('notify.REFRESH_ERROR'))
        this.$router.push({ name: 'Login' })
      }
    },
    serverError (error) {
      if (error) {
        this.$awn.alert(this.$t('notify.SERVER_ERROR'))
      }
    },
    notFoundError (error) {
      if (error) {
        this.$router.push({ name: 'NotFound' })
      }
    },
    requestError (error) {
      if (error) {
        this.$awn.alert(this.$t('notify.REQUEST_ERROR'))
      }
    }
  }
}
